window.APP = window.APP || {};
import jQuery from 'jquery';
import $ from 'jquery';
import dayjs from 'dayjs';

APP.availabilityChecker = (function ($) {
    'use strict';

    var AVAILABILITY_CHECKER = '.availability-checker';

    var RESTAURANT_DROPDOWN_DATE = '.js-availability-checker-date';
    var RESTAURANT_DROPDOWN_SITTING = '.js-availability-checker-sitting';
    var RESTAURANT_DROPDOWN_GUESTS = '.js-availability-checker-guests';
    var SPA_DROPDOWN_DATE = '.js-spa-checker-date';

    var MAKE_BOOKING_BTN = '.js-make-reservation';

    var DINING_EXCEEDED_FUTURE = 'dining-date-exceededFuture';

    var UNAVAILABLE_CALENDAR_HOVER = window.unavailableDateMessage;
    var AVAILABLE_CALENDAR_HOVER = window.availableDateMessage;

    if (typeof window.availableDates === 'undefined') {
        window.availableDates = [true];
    }

    var startingDate = new Date();

    // Reset startingDate to first thing in the morning
    startingDate.setHours(0);
    startingDate.setMilliseconds(0);
    startingDate.setSeconds(0);
    startingDate.setMinutes(0);

    var endDate = new Date();

    var spaStartingDate = new Date();
    var spaEndDate = new Date();
    var spaisDateCappedByDayLimit = false;
    let spaBookingMaxDate = null;

    // If the valid booking period has been set then update endDate to include that period
    if (typeof window.validBookingPeriod !== 'undefined' && window.validBookingPeriod !== null) {
        endDate.setDate(endDate.getDate() + parseInt(window.validBookingPeriod, 10));
    } else {
        endDate.setDate(endDate.getDate() + 90);
        window.validBookingPeriod = 90;
    }

    if (typeof window.validSpaBookingPeriodNumber !== 'undefined' && window.validSpaBookingPeriodNumber !== null) {
        spaEndDate.setDate(spaEndDate.getDate() + parseInt(window.validSpaBookingPeriodNumber, 10));
    } else {
        spaEndDate.setDate(spaEndDate.getDate() + 90);
        window.validSpaBookingPeriodNumber = 90;
    }

    if (window.spaBookingMinDateRestriction != null) {
        var currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);

        var minDateObj = new dayjs.unix(window.spaBookingMinDateRestriction).toDate();

        // Only update the min date if it is in the future
        if (minDateObj > currentDate) {
            spaStartingDate = minDateObj;
            console.log('BookingRestriction: New minimum date set for InPage SpaBooking', spaStartingDate);
        }
    }

    if (window.spaBookingMaxDateRestriction != null) {
        spaBookingMaxDate = new dayjs.unix(window.spaBookingMaxDateRestriction).toDate();

        if (spaBookingMaxDate < spaEndDate) {
            console.log("BookingRestriction: B4T SpaBooking max date is sooner than booking period max date")
            spaEndDate = spaBookingMaxDate;
            spaisDateCappedByDayLimit = false;
        } else {
            spaisDateCappedByDayLimit = true;
        }
    } else {
        spaisDateCappedByDayLimit = true;
    }

    console.log('BookingRestriction: New maximum date set for InPage SpaBooking', spaEndDate);


    var init = function () {
        $(document).ready(function () {
            initialiseCalendars();
            initialiseDiningDropdowns();

            $('body').on('click', MAKE_BOOKING_BTN, onMakeBookingBtn);

            //$('#DesiredDate').on('focus', function (e) {
            //    e.preventDefault();
            //    e.stopPropagation();
            //    document.body.scrollTop = 0;
            //});
        });
    };

    function initialiseFrenchRegion() {
        $.datepicker.regional['fr'] = {
            closeText: "Fermer",
            prevText: "Précédent",
            nextText: "Suivant",
            currentText: "Aujourd'hui",
            monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
                "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
            monthNamesShort: ["janv.", "févr.", "mars", "avr.", "mai", "juin",
                "juil.", "août", "sept.", "oct.", "nov.", "déc."],
            dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
            dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
            weekHeader: "Sem.",
            dateFormat: "dd/mm/yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ""
        };
    }

    function initialiseCalendars() {

        if (window.preferredCulture == null || window.preferredCulture == '') {
            $.datepicker.setDefaults($.datepicker.regional['en']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional[window.preferredCulture]);
        }

        $(RESTAURANT_DROPDOWN_DATE).datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: startingDate,
            maxDate: endDate,
            firstDay: 1,
            beforeShow: function (input, inst) {
                inst.dpDiv.addClass('availability-checker-date themed-calendar');
            },
            beforeShowDay: checkDateInBounds,
            onChangeMonthYear: function (year, month, obj) {
                // Check if new month is 3 both existing
                setTimeout(function () {
                    if (month === (endDate.getMonth() + 1)) {
                        showValidBookingPeriodMessage(obj.dpDiv);
                    } else {
                        hideValidBookingPeriodMessage(obj.dpDiv);
                    }
                }, 100);
            }
        });

        $(SPA_DROPDOWN_DATE).datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: spaStartingDate,
            maxDate: spaEndDate,
            firstDay: 1,
            beforeShow: function (input, inst) {
                inst.dpDiv.addClass('availability-checker-date themed-calendar');
                const html = $('#ui-datepicker-div')
                $('.availability-checker__spa .custom-date-select__wrapper').append(html[0]);
                $("#main").addClass("position-relative")
                setTimeout(function () {

                    const datepickerColumns = $("#ui-datepicker-div td")
                    datepickerColumns.each(function () {
                        if (this.hasAttribute("title")) {
                            this.removeAttribute('title')
                        }
                    })

                }, 100)
            },
            onClose: function (selectedDate) {
                $("#main").removeClass("position-relative");
                $('body').removeClass('opened');
            },
            beforeShowDay: checkSpaDateInBounds,
            onSelect: function (date, inst) {

                const dateParts = date.split("/");
                const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                const todaysDate = new Date();
                const element = document.querySelector(".js-todays-date");
                const cancellationMessage = element.getAttribute('data-cancellationmessage');
                element.innerHTML = cancellationMessage

                if (dateObject.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                    element.classList.remove("hide");
                }
                else {
                    element.classList.add("hide")
                }
            },
            onChangeMonthYear: function (year, month, obj) {
                // Check if new month is 3 both existing
                setTimeout(function () {
                    if (spaisDateCappedByDayLimit && month === (spaEndDate.getMonth() + 1)) {
                        showValidBookingSpaPeriodMessage(obj.dpDiv);
                    } else {
                        hideValidBookingSpaPeriodMessage(obj.dpDiv);
                    }

                    const datepickerColumns = $("#ui-datepicker-div td")
                    datepickerColumns.each(function () {
                        if (this.hasAttribute("title")) {
                            this.removeAttribute('title')
                        }
                    })
                }, 100);
            }
        });

        //$('#mobileCalendar').datepicker({
        //    dateFormat: 'dd/mm/yy',
        //    dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        //    minDate: startingDate,
        //    maxDate: endDate,
        //    firstDay: 1,
        //    beforeShow: function (input, inst) {
        //        inst.dpDiv.addClass('availability-checker-date themed-calendar');
        //    },
        //    beforeShowDay: checkDateInBounds,
        //    onChangeMonthYear: function (year, month, obj) {
        //        // Check if new month is 3 both existing
        //        setTimeout(function () {
        //            if (month === (endDate.getMonth() + 1)) {
        //                showValidBookingPeriodMessage(obj.dpDiv);
        //            } else {
        //                hideValidBookingPeriodMessage(obj.dpDiv);
        //            }
        //        }, 100);
        //    },
        //    onSelect: function (selectedDate) {
        //        var selectedDate = $('#mobileCalendar').datepicker('getDate');

        //        var strDate = prefixZeroDate(selectedDate.getDate()) + '/' + prefixZeroDate(selectedDate.getMonth() + 1)  + '/' + selectedDate.getFullYear();
        //        $('#DesiredDate').val(strDate);
        //    }
        //});

        // Remove currently selected date, feels a bit messy
        $(RESTAURANT_DROPDOWN_DATE).datepicker('setDate', null);
        $(RESTAURANT_DROPDOWN_DATE).find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
    }


    function prefixZeroDate(val) {
        return (val < 10) ? "0" + val : val;
    }

    function initialiseDiningDropdowns() {
        $(RESTAURANT_DROPDOWN_SITTING).select2({
            dropdownParent: $('body'),
            minimumResultsForSearch: -1,
            allowClear: false
        });

        $(RESTAURANT_DROPDOWN_GUESTS).select2({
            dropdownParent: $('body'),
            minimumResultsForSearch: -1,
            allowClear: false
        });
    }

    function onMakeBookingBtn(e) {
        e.preventDefault();

        // Calculate size of header so we can avoid scrolling over it
        var headerOffset = 0;

        if ($('.site-wide-banner').length > 0) headerOffset += $('.site-wide-banner').height();
        if ($('header.header').length > 0) headerOffset += $('header.header').height();

        if ($('.availability-checker').length > 0) {
            $('html, body').animate({
                scrollTop: ($('.availability-checker').offset().top - headerOffset)
            }, 800);
        }
    }

    function showValidBookingPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header:last').addClass(DINING_EXCEEDED_FUTURE).attr('data-validBookingPeriod', window.validBookingPeriodMessage);
    }

    function hideValidBookingPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header:last').removeClass(DINING_EXCEEDED_FUTURE);
    }

    function showValidBookingSpaPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header:last').addClass(DINING_EXCEEDED_FUTURE).attr('data-validBookingPeriod', window.validSpaBookingPeriodMessage);
    }

    function hideValidBookingSpaPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header:last').removeClass(DINING_EXCEEDED_FUTURE);
    }

    function checkDateInBounds(date) {
        if (date >= startingDate && date <= endDate) {
            return [true, "", AVAILABLE_CALENDAR_HOVER];
        } else {
            return [false, "", UNAVAILABLE_CALENDAR_HOVER];
        }
    }

    function checkSpaDateInBounds(date) {
        if (date >= startingDate && date <= spaEndDate) {
            return [true, "", AVAILABLE_CALENDAR_HOVER];
        } else {
            return [false, "", UNAVAILABLE_CALENDAR_HOVER];
        }
    }

    return {
        init: init
    };

})(jQuery);
